
import { connect } from 'react-redux';
import { playLive } from '../actions/MediaPlayerActions';
import { unlockPlayer } from '../actions/AovivoBarActions';
import AovivoBar from '../components/AovivoBarComponent';

const mapStateToProps = (state) => {
    const aovivoBar = state.aovivoBar;

    return {
        isLive: aovivoBar.MediaPlayer.isLive,
        isMobile: state.clientInfo.isMobile,
        locked: aovivoBar.AovivoBar.locked,
    };
};

const mapDispatchToProps = (dispatch) => ({
    playLive: () => {
        dispatch(playLive());
    },
    unlockPlayer: () => {
        dispatch(unlockPlayer());
    },
});

const AovivoBarContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(AovivoBar);

export default AovivoBarContainer;
